module.exports = __webpack_public_path__ + "static/img/teacher1.debe199b.png";